import React from 'react'
import PropTypes from 'prop-types'
import { modifyImageSizeProps } from 'common/helpers'


/**
 *
 * @param {Object} [options] - describe what props are required!
 * @param {Boolean} options.lambda - means that one of prop "w" or "h" required by ComposedComponent
 */
export default (options = {}) => (ComposedComponent) => {

  const { lambda } = options

  const WrappedComponent = (props) => {
    const modifiedProps = modifyImageSizeProps(props)

    return (
      <ComposedComponent {...modifiedProps} />
    )
  }

  WrappedComponent.WrappedComponent = ComposedComponent

  WrappedComponent.displayName = `imageSizes(${ComposedComponent.displayName || ComposedComponent.name})`

  const lambdaPropType = !lambda ? PropTypes.number : (props, propName, componentName) => {
    if (!props.w && !props.h) {
      return new Error(`One of props 'w' or 'h' was not specified in '${componentName}'`)
    }
  }

  WrappedComponent.propTypes = {
    ...ComposedComponent.propTypes,
    src: PropTypes.string.isRequired,
    srcSet: PropTypes.string,
    w: lambdaPropType,
    h: lambdaPropType,
    x2: PropTypes.oneOfType([ PropTypes.number, PropTypes.bool ]),
    x3: PropTypes.oneOfType([ PropTypes.number, PropTypes.bool ]),
  }

  return WrappedComponent
}
